import { transformTableQueryForKy } from "../../helpers/tableHelpers";
import { CustomerPortalRequestTableQuery } from "../../pages/requests/models";
import {
  privateGet,
  privatePost,
  privatePut,
} from "../clients/createPrivateClient";
import {
  CPRequestDetail,
  CPRequestFormDataForOwnerResult,
  CPRequestMessageToAdd,
  CPRequestStateToChangeInput,
  CPRequestToAdd,
  TableResultCPRequest,
} from "../models/unified";

export default {
  getRequests: async (query: CustomerPortalRequestTableQuery) => {
    const result = await privateGet<TableResultCPRequest>(
      "customerPortal/request/v2",
      {
        ...transformTableQueryForKy(query),
      },
    );

    return result;
  },
  addRequest: async (values: CPRequestToAdd) => {
    const result = await privatePost<CPRequestDetail>(
      "customerPortal/request/v2",
      values,
    );

    return result;
  },
  getRequestDetail: async (requestId: string) => {
    const result = await privateGet<CPRequestDetail>(
      `customerPortal/request/v2/${requestId}`,
    );

    return result;
  },
  addMessage: async (params: {
    requestId: string;
    values: CPRequestMessageToAdd;
  }) => {
    const result = await privatePost<CPRequestDetail>(
      `customerPortal/request/v2/${params.requestId}/message`,
      params.values,
    );

    return result;
  },
  changeState: async (params: {
    requestId: string;
    values: CPRequestStateToChangeInput;
  }) => {
    const result = await privatePut<CPRequestDetail>(
      `customerPortal/request/v2/${params.requestId}/state`,
      params.values,
    );

    return result;
  },
  getCustomerData: async (customerId: string) => {
    const result = await privateGet<CPRequestFormDataForOwnerResult>(
      `customerPortal/requestFormDataForOwner/v2/customer/${customerId}`,
    );

    return result;
  },
};
